// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export let RowPropertyClass = function ()
{
    this.Id = "";
    this.Group = "";
    this.SortIndex = 0;
    this.LocalizationKey = "";
    this.Hidden = false;
    this.visible = true;
    this.tooltipKey = "";
    this.arrayList = new Array();
}

RowPropertyClass.prototype.Properties = function ()
{
    return this.arrayList;;
}

RowPropertyClass.prototype.callBack = function (v)
{
    this.arrayList = v;
}

RowPropertyClass.prototype.Apply = function (sourceItem)
{
    this.visible = sourceItem.visible;
    this.arrayList = sourceItem.Properties;
}

RowPropertyClass.prototype.ToString = function ()
{
    return group + "." + this.LocalizationKey;
}